import {defineSlotRecipe} from '@chakra-ui/react3'

export const colorSwatchesRecipe = defineSlotRecipe({
    className: 'leap-color-swatches',
    slots: [
        'root',
        'colorLabel',
        'selectedColorValue',
        'swatchGroups',
        'swatchGroup',
        'groupLabel',
        'row',
        'swatch',
        'swatchOuter',
        'swatchInner',
        'swatchImage',
        'variationText'
    ],
    base: {
        swatchGroups: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16'
        },
        swatchGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-6'
        },
        groupLabel: {
            color: {base: 'text.tertiary', s: 'text.secondary'},
            textStyle: {base: 'heading.small', s: 'body.xsmall'}
        },
        row: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        swatch: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            cursor: 'pointer',
            _disabled: {
                cursor: 'not-allowed'
            }
        },
        swatchOuter: {
            position: 'relative',
            _unavailable: {
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    backgroundColor: 'primary.base.black',
                    // multiply the square size by √2 to get the diagonal length
                    height: 'calc(100% * 1.4)', // update insetBlockStart if changing the height
                    insetBlockStart: 'calc(-100% * 0.2)',
                    width: '1px', // update insetInlineStart if changing the width
                    insetInlineStart: 'calc(50% - 0.5px)',
                    transform: 'rotate(-45deg)',
                    transformOrigin: 'center center',
                    pointerEvents: 'none'
                }
            }
        },
        swatchInner: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'round',
            overflow: 'hidden',
            flexShrink: 0,
            _groupChecked: {
                outline: '{borders.sm} {colors.border.brand}',
                outlineOffset: '2px'
            },
            _groupFocusVisible: {
                outline: '{borders.md} {colors.border.brand}',
                outlineOffset: '2px'
            }
        },
        swatchImage: {
            overflow: 'hidden',
            objectFit: 'cover',
            display: 'block',
            width: '100%',
            height: '100%',
            position: 'relative',
            _after: {
                content: '""',
                position: 'absolute',
                inset: '0',
                border: 'sm',
                borderColor: 'border.subtle',
                borderRadius: 'round'
            }
        },
        variationText: {
            color: 'text.secondary'
        }
    },
    variants: {
        size: {
            18: {
                swatch: {
                    width: 'spacing-26',
                    height: 'spacing-26'
                },
                swatchInner: {
                    width: 'spacing-18',
                    height: 'spacing-18'
                }
            },
            26: {
                swatch: {
                    width: {base: 'spacing-40', s: 'spacing-36'},
                    height: {base: 'spacing-40', s: 'spacing-36'}
                },
                swatchInner: {
                    width: 'spacing-26',
                    height: 'spacing-26'
                }
            }
        }
    },
    defaultVariants: {
        size: 26
    }
})
